import React from "react";
import alert from "../assets/img/alert.svg";
import tracker from "../assets/img/workflow.svg";
import closedRisks from "../assets/img/closed_events.svg";
import insight from "../assets/img/historical_insights.svg";
import extlinks from "../assets/img/external_links.svg";
import qualityRisks from "../assets/img/quality_risks.svg";
import managedata from "../assets/img/manage_data.svg";
import { modulesKeyMap, tabsKeyMap } from "../components/AuthConfig/actionMap";

const WFTracking = React.lazy(() =>
  import("../components/WFTracking/WFTracking")
);
const ClosedEvents = React.lazy(() =>
  import("../components/ClosedEvents/ClosedEvents")
);
const HistInsight = React.lazy(() =>
  import("../components/HistInsight/HistInsight")
);
const ExternalTools = React.lazy(() =>
  import("../components/Links/ExternalTools")
);
const GeoMap = React.lazy(() => import("../components/Maps/GeoMap"));
const CollapseComponentLayout = React.lazy(() =>
  import("../components/CollapseComponent/CollapseComponentLayout")
);
const RisksBasePage = React.lazy(() =>
  import("../components/RiskDashBoard/RisksBasePage")
);
const WFSummaryBasePage = React.lazy(() =>
  import("../components/WFSummary/WFSummaryBasePage")
);
const ManageDataPage = React.lazy(() =>
  import("../components/ManageData/ManageData")
);
const DCContingencyPage = React.lazy(() => 
  import("../components/ManageData/DCContingency/DCContingency")
);
const QualityRisksBasePage = React.lazy(() =>
  import("../components/QualityRisks/QualityRisksBasePage")
);

const dashboardRoutes = [
  {
    path: "/Summary",
    name: "Risk Summary",
    sidebarName: "Operational Risk",
    image: closedRisks,
    component: WFSummaryBasePage,
    hide: false,
    isEventType: true,
    redirect: false,
    allowed_roles: ["Admin", "Operator", "ReadOnlyUser"],
    moduleKey: modulesKeyMap.OPERATIONAL,
    tabKey: tabsKeyMap.OPERATIONAL_SUMMARY,
  },
  {
    path: "/Management",
    name: "Risk Alerts & Management",
    sidebarName: "Management",
    image: alert,
    component: WFSummaryBasePage,
    hide: true,
    isEventType: false,
    redirect: false,
    allowed_roles: ["Admin", "Operator", "ReadOnlyUser"],
    moduleKey: modulesKeyMap.OPERATIONAL,
    tabKey: tabsKeyMap.OPERATIONAL_MANAGEMENT,
  },
  {
    path: "/workflow",
    name: "Work Flow",
    image: insight,
    component: CollapseComponentLayout,
    hide: true,
    isEventType: false,
    redirect: true,
    allowed_roles: ["Admin", "Operator", "ReadOnlyUser"],
    moduleKey: modulesKeyMap.WORKFLOW,
  },
  {
    path: "/closedRisks",
    name: "Risk Management",
    sidebarName: "Management",
    image: tracker,
    component: ClosedEvents,
    hide: true,
    isEventType: false,
    redirect: false,
    allowed_roles: ["Admin", "Operator", "ReadOnlyUser"],
  },
  {
    path: "/StrategicSummary",
    name: "Strategic Chart",
    sidebarName: "Strategic Risk",
    image: extlinks,
    component: RisksBasePage,
    hide: false,
    isEventType: true,
    redirect: true,
    allowed_roles: ["Admin", "Operator", "ReadOnlyUser"],
    moduleKey: modulesKeyMap.STRATEGIC,
    tabKey: tabsKeyMap.STRATEGIC_SUMMARY,
  },
  {
    path: "/QualityCPM",
    name: "Quality Risks",
    sidebarName: "Quality Risk",
    image: qualityRisks,
    component: QualityRisksBasePage,
    hide: false,
    isEventType: true,
    redirect: true,
    allowed_roles: ["Admin", "Operator", "ReadOnlyUser"],
    moduleKey: modulesKeyMap.QUALITY_RISKS,
    tabKey: tabsKeyMap.QUALITY_COMPLAINT_DETAILS,
  },
  {
    path: "/ComplaintDetails",
    name: "Complaint Details",
    sidebarName: "Quality Risk",
    image: qualityRisks,
    component: QualityRisksBasePage,
    hide: true,
    isEventType: true,
    redirect: true,
    allowed_roles: ["Admin", "Operator", "ReadOnlyUser"],
    moduleKey: modulesKeyMap.QUALITY_RISKS,
    tabKey: tabsKeyMap.QUALITY_COMPLAINT_DETAILS,
  },
  {
    path: "/insight",
    name: "Risk Insights",
    sidebarName: "Risk Insights",
    image: insight,
    component: HistInsight,
    hide: false,
    isEventType: false,
    redirect: false,
    allowed_roles: ["Admin", "Operator", "ReadOnlyUser"],
    moduleKey: modulesKeyMap.RISK_INSIGHTS,
  },
  {
    path: "/ManageData",
    name: "Manage Data",
    sidebarName: "Manage Data",
    image: managedata,
    component: ManageDataPage,
    hide: false,
    isEventType: false,
    redirect: false,
    allowed_roles: ["Admin", "Operator", "ReadOnlyUser"],
    moduleKey: modulesKeyMap.MANAGE_DATA,
  },
  {
    path: "/DCContingency",
    name: "DC Contingency",
    sidebarName: "DC Contingency",
    image: managedata,
    component: DCContingencyPage,
    hide: true,
    isEventType: false,
    redirect: false,
    allowed_roles: ["Admin", "Operator", "ReadOnlyUser"],
    moduleKey: modulesKeyMap.MANAGE_DATA,
  },
  // {
  //   path: "/StrategicSummary",
  //   name: "Risk Summary",
  //   sidebarName: "Insights",
  //   image: closedRisks,
  //   component: WFSummaryBasePage,
  //   hide: true,
  //   redirect: false,
  //   allowed_roles: ["Admin", "Operator", "ReadOnlyUser"],
  // },
  {
    path: "/external",
    name: "External Tools",
    image: extlinks,
    component: ExternalTools,
    hide: true,
    isEventType: false,
    redirect: false,
    allowed_roles: ["Admin", "Operator", "ReadOnlyUser"],
  },
  {
    path: "/detailPage",
    name: "Detail Page",
    image: extlinks,
    component: RisksBasePage,
    hide: true,
    isEventType: false,
    redirect: true,
    allowed_roles: ["Admin", "Operator", "ReadOnlyUser"],
  },
  {
    path: "/tracking",
    name: "Workflow Tracking",
    image: extlinks,
    component: WFTracking,
    hide: true,
    isEventType: false,
    redirect: true,
    allowed_roles: ["Admin", "Operator", "ReadOnlyUser"],
  },
  {
    path: "/mapView",
    name: "Map View",
    image: extlinks,
    component: GeoMap,
    hide: true,
    isEventType: false,
    redirect: true,
    allowed_roles: ["Admin", "Operator", "ReadOnlyUser"],
  },

  // {
  //   path: "/histInsight",
  //   name: "Historical Insight",
  //   icon: "pe-7s-bell",
  //   component: HistInsight,
  //   hide:false,
  //   redirect:false,
  //   allowed_roles:['Admin', 'Operator', 'ReadOnlyUser']
  // },

  // {
  //   path: "/iMaps",
  //   name: "Interactive Maps",
  //   icon: "pe-7s-map-2",
  //   component: IMaps,
  //   hide:false,
  //   redirect:false,
  //   allowed_roles:['Admin', 'Operator', 'ReadOnlyUser']
  // },
];

export default dashboardRoutes;
